<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { DevicesService } from '@/services/devices.service';

export default {
  name: 'TypeFilter',

  extends: BaseFilter,

  data() {
    return {
      name: 'type'
    };
  },

  methods: {
    getData() {
      return DevicesService.getFilteredTypes({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
